import { BACKEND_BASE_URL } from "./backendBaseUrl";

export const PERMISSION_BASE_URL = BACKEND_BASE_URL + "/permission";
export const GET_FOLDER_PERMISSION_LIST = "/folder";
export const GET_PASSWORD_PERMISSION_LIST = "/password";
export const GET_ENV_PERMISSION_LIST = "/env";
